// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"eea409c3","352":"d3bf554c","416":"a9289445","538":"c2d67a5d","566":"2fa94819"}[chunkId] + ".chunk.js";
};